import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import {PipelineLicenseStageDto,PLStageActivityDto,PLStakeholderMatrixDto,PLStakeholderMatrixRaciDto, PipelineTemplateDto, PipelineLicenseCategoryDto} from '@cradua/data';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Router} from '@angular/router'
import Swal from 'sweetalert2';
import { AuthenticationService } from 'apps/epims/mrsoftepims/src/app/services/auth.service';
import { User } from '@cradua/domain';

@Component({
  selector: 'cradua-template',
  templateUrl: './template.component.html',
  styleUrls: ['./template.component.css']
})
export class TemplateComponent implements OnInit {
@Output() submitevent = new EventEmitter();
@Output() deletevent = new EventEmitter();
@Input() stages: PipelineLicenseStageDto[];
@Input() plstageactivities: PLStageActivityDto[];
@Input() plstakeholdersmatrix: PLStakeholderMatrixDto[];
@Input() plstakeholdersmatrixraci: PLStakeholderMatrixRaciDto[];
@Input() templates: PipelineTemplateDto[];
@Input() stagecategories: PipelineLicenseCategoryDto[];
@Output() isTemplateview = new EventEmitter();
user: User;

templateForm: FormGroup
  isnewTemp: boolean;
  constructor(private fb: FormBuilder, private matSnackBar: MatSnackBar, private router: Router, private authServ: AuthenticationService,) { }

  ngOnInit(): void {
    this.user = this.authServ.getUser();

    this.templates = this.templates.sort((a, b) => new Date(a.dateCreated).getMilliseconds() - new Date(b.dateCreated).getMilliseconds())
    this.templateForm = this.fb.group({
      PipelineTemplateName: ['', Validators.required],
      dateCreated: [new Date()],
      CreatedByName: [this.user.StaffName],
      CreatedById: [this.user.Id]
    });

  }

filterStage(id, tId) {
return this.stages.filter(stage => stage.PipelineLicenseCategoryId === id && stage.TemplateId === tId);
}

countTask(id, tId) {
let totalTask = 0;
for(let stage of this.filterStage(id, tId)) {
  totalTask += this.filterTask(stage.id).length;
}
return totalTask;
}

filterTask(id) {
  return this.plstageactivities.filter(task => task.PLStageId === id);
}


updateTemplate(data) {
this.templateForm.patchValue(data);
}

changStatus(data: PipelineTemplateDto) {
  const newData = {
    id: data.id,
    Status: data.Status,    
  }
  let statustext;
  if(newData.Status === 'ACTIVE') {
    statustext = `You want to deactivate template!`
  } else {
    statustext = `You want to activate template!`
  }

  Swal.fire({
    title: 'Are you sure?',
    text: statustext,
    type: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes, !',
    cancelButtonText: 'No, keep it',
  }).then((result) => {
    if (result.value) {
      if(newData.Status.trim() === 'ACTIVE') {
        newData.Status = 'INACTIVE';
      } else {
        newData.Status = 'ACTIVE';
      }

      this.submitevent.emit(newData);
    
      Swal.fire(
        'Message!',
        'Your status has been changed.',
        'success'
      );
    } else if (result.dismiss === Swal.DismissReason.cancel) {
      Swal.fire('Cancelled', 'Your status was reversed:)', 'error');
    }
  });
}



deleteTemplate(id) {
  this.deletevent.emit(id);
}

newTemplate() {
  this.isnewTemp =  true;
}

veiwTemp() {
  this.isnewTemp = false;
}


templateView(id, catId) {
 this.isTemplateview.emit({id: id, isview: true, selectedCategoryId: catId});
}

onSubmitTemplate(data) {
  if(this.templateForm.valid) {
  this.submitevent.emit(data);
  } else {
  this.matSnackBar.open('Template name must not be empty!', 'Close', {duration: 3000});
  }
}
}
